import React from 'react';
import './WhatWeDoSection.css';

const WhatWeDoSection = () => {
  const features = [
    {
      icon: "📊",
      title: "Personalised Dashboard",
      description: "Manage bookkeeping, tax, and compliance in one secure portal."
    },
    {
      icon: "⏱️",
      title: "Track Work Status in Real Time",
      description: "Monitor project progress, uploaded documents, deadlines, and communication with complete visibility from start to finish."
    },
    {
      icon: "🔐",
      title: "Secure Document Vault",
      description: "Safely store and access all your U.S. tax, financial, and incorporation documents."
    },
    {
      icon: "👥",
      title: "Dedicated Account Managers",
      description: "Get 1-on-1 support from certified accountants."
    },
    {
      icon: "💳",
      title: "Flexible Pricing Plans",
      description: "Pay only for what you use — no hidden fees."
    },
    {
      icon: "⏰",
      title: "Smart Filing Reminders",
      description: "Never miss a U.S. tax or compliance deadline with our timely reminders."
    }
  ];

  return (  
    <section className="what-we-do-section">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h1 className="section-title1 mb-4">
              Why Businesses Choose BooksComply
            </h1>
            <p className="lead text-white mb-5 mx-auto" style={{maxWidth: '800px'}}>
              At BooksComply, clients can log in anytime to track their projects, see real-time task updates, and communicate directly with their accountants. This level of visibility builds trust and accountability — making us one of the most transparent accounting partners for U.S. businesses.
            </p>
            <div className="title-underline"></div>
          </div>
        </div>
        
        <div className="row">
          {features.map((feature, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="feature-card h-100 d-flex flex-column">
                <div className="text-center mb-3">
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="feature-title">
                  {feature.title}
                </h3>
                <p className="feature-description">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
